<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">AlarmWatch</h2>
      <br />
      
    </el-row>
    <br />
    <el-card>
      <el-row>
        <el-form
          :inline="true"
          :model="query"
          :label-position="'top'"
          class="demo-form-inline"
        >
          <el-col>
              <el-form-item label="Date">
                <el-date-picker
                  v-model="query.dateRange"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  :format="pickerOptions.format"
                  range-separator="-"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  align="right"
                ></el-date-picker>
              </el-form-item>
               <el-form-item label="Partner" prop="partner">
              <el-select
              @change="loadCustomers"
                v-model="query.partner"
                placeholder="Select"
                filterable
                clearable
              >
                <el-option
                  v-for="item in partnerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Customer" prop="customer">
              <el-select
              @change="load"
                v-model="query.customer"
                placeholder="Select"
                filterable
                clearable
              >
                <el-option
                  v-for="item in customerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Telemetry">
              <el-select
                v-model="query.telemetry"
                placeholder="Select"
                clearable
              >
                <el-option
                  v-for="item in telemetriesValue"
                  :key="item.key"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Severity">
              <el-select
                v-model="query.levels"
                placeholder="Select"
                clearable
                multiple
              >
                <el-option
                  v-for="item in levels"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
        <el-col>
          <el-button
            type="primary"
            @click="
              query.page = 1;
              load();
            "
            >Filter</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
        <el-col>
          <el-table
            v-loading="loading"
            :data="searchResult.alarmWatches"
            class="border"
          >
            <el-table-column type="index" label="Id">
              <template slot-scope="scope">
                <span @click="copyIdToClipboard(scope.row._id)">
                  {{ itemIndex(scope) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="createdAt">
            <template slot-scope="scope">
            {{dayFormat(scope.row.createdAt)}}
            </template></el-table-column>
            <el-table-column prop="partner" label="Partner"></el-table-column>
            <el-table-column prop="customer" label="Customer">
            </el-table-column>
            <el-table-column prop="level" label="Level" width="100px;" >
              <template slot-scope="scope">
                <span >
                  {{ scope.row.level.name}}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="telemetry" label="Telemetry" />
            <el-table-column prop="sensor" label="Sensor" />
            <el-table-column prop="score" label="Score" width="100px;" >
              <template slot-scope="scope">
                <span >
                  {{ scope.row.score.toFixed(4)}}
                </span>
              </template>
            </el-table-column>
             <el-table-column prop="_id" label="Go To" >
              <template slot-scope="scope">
                 <el-button @click="openMeasurement(scope.row)"> Click to go details</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>

        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>



<script>

import { mapState, mapActions } from "vuex";
import dayjs from "dayjs"
export default {
  name: "AlarmWatch",
  components: {  },
  data() {
    return {
      pickerOptions: {
        format:
          "DD-MM-YYYY HH:mm:ss".replace(/D/g, "d") //element ui date format require lowercase
          .replace(/Y/g, "y"),
        shortcuts: [
          {
            text: "Last Day",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
                    {
            text: "Last Month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7 * 4);
              picker.$emit("pick", [start, end]);
            },
          },
                    {
            text: "Last 3 Month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7 * 4 * 3);
              picker.$emit("pick", [start, end]);
            },
          }
        ],
      },
      levels:[
        {
          label:"health",
          value:0
        },
                {
          label:"attention",
          value:1
        },
                {
          label:"hazard",
          value:2
        },
                {
          label:"critical",
          value:3
        }
      ],
      query: {
        customer: "",
        partner: "",
        levels: [],
        telemetry: "",
        dateRange: [new Date().getTime() - 3600 * 1000 * 24 * 7 * 4 * 12, new Date()],
        page: 1,
        pageSize: 10,
      },
      pageSizes: [10, 25, 50, 75],
    };
  },
  created() {
    this.getCustomers();
    this.getPartners();
    this.getAlarmWatch(this.query);
  },
  computed: {
    ...mapState("alarmWatch", ["searchResult", "loading", "telemetries"]),
    ...mapState("partner", ["partners","customers"]),
    customerSelect() {
      return this.customers.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },
    partnerSelect() {
      return this.partners.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },
    telemetriesValue(){
       return this.telemetries.map((x) => {
        return {
          value: x.name,
          label: `${x.name}`,
          key: x.name,
        };
      });
    }
  },
  methods: {
    async loadCustomers(){
      this.query.customer="";
      await this.getCustomers({partner:this.query.partner});
      this.getAlarmWatch(this.query);
    },
    openMeasurement(row){
      console.log(row)
      window.open(`https://${row.customerDomain}/measurement/${row.measurementId}`,'_blank')
    },
      dayFormat(createdAt) {
      return dayjs(createdAt).format("DD-MM-YYYY HH:mm:ss");
    },
    ...mapActions("alarmWatch", [
      "getAlarmWatch","getTelemetries",
    ]),
    ...mapActions("partner", ["getPartners","getCustomers"]),
    itemIndex(scope) {
      return this.query.pageSize * (this.query.page - 1) + scope.$index + 1;
    },
    copyIdToClipboard(id) {
      this.$clipboard(id);
      this.$message.info("'" + id + "' " + "copy to clipboard success");
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    load() {
      this.getAlarmWatch(this.query);
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  watch:{
    "query.customer":function(){
      this.getTelemetries(this.query.customer);
    }
  }
};
</script>
<style scoped>
.color-circle {
  height: 20px;
  width: 20px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}
abbr {
  max-width: 150px;
  word-break: initial;
}
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>